import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=081b3f32&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=081b3f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b3f32",
  null
  
)

export default component.exports